<template>
  <!-- 首页未读公告弹窗 -->
  <el-dialog :title="announcementSelected.title" :visible.sync="dialogVisible" custom-class="annocedialog" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false" width="1000px">
    <div class="ide-content">
      <p class="time">{{announcementSelected.createTime}}</p>
      <div class="downloadArea" v-if="announcementSelected.attachFileJson && announcementSelected.attachFileJson.length > 0">
        <ul>
          <li v-for="attachFile in announcementSelected.attachFileJson" :key="attachFile.index">
            <span class="title" :title="attachFile.fileName">{{(attachFile.index+1)+','+attachFile.fileName}}</span>
            <el-button type="text" @click="download(attachFile)"> 下载</el-button>
          </li>
        </ul>
      </div>
      <div class="content-box" v-html="announcementSelected.content"></div>
    </div>
    <div slot="footer" class="dialog-footer" align="center">
      <el-button type="info" @click="nextAnnouncement()" v-if="announcementlist.length>0">
        下一条({{(announcementlistTotal-announcementlist.length)+'/'+announcementlistTotal}})
      </el-button>
      <el-button type="info" @click="nextAnnouncement()" v-else>我知道了</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import * as homeServices from '../home-service'
  import FormatDate from '@core/filters'
  export default {
    data() {
      return {
        //公告
        announcementlist: [],
        announcementlistTotal: 0,
        announcementSelected: {},
        dialogVisible: false
      }
    },
    mounted() {
      this.getAnnouncementUnread()
    },
    methods: {
      getAnnouncementUnread() {
        this.announcementlist = []
        this.announcementlistTotal = 0

        homeServices.getAnnouncementUnread().subscribe(success => {
          if (Array.isArray(success.data) && success.data.length) {
            this.announcementlist = success.data.map((item) => {
              item.attachFileJson = JSON.parse(item.attachFileJson || '[]')
              item.createTime = FormatDate(item.createTime, "yyyy-MM-dd HH:mm:ss")
              return item
            })
            this.announcementlistTotal = this.announcementlist.length
            this.announcementSelected = this.announcementlist.pop()
            this.dialogVisible = true
          }
        })
      },
      nextAnnouncement() {
        // 弹窗模式为单次时才设为已读
        this.announcementSelected.popMode == 0 && this.setUnreadRead()
        this.dialogVisible = this.announcementlist.length > 0
        this.announcementSelected = this.announcementlist.pop() || {}
      },
      setUnreadRead() {
        let params = {
          announcementIds: [this.announcementSelected.id]
        }
        homeServices.setUnreadRead(params)
      },
      //公告框内下载附件
      download(item) {
        location.href = `/popadmin/admin/download/file?url=` + item.url +'&fileName=' + item.fileName
      },
    },
  }
</script>
<style lang="less">
  .annocedialog {
    .el-dialog__footer {
      box-shadow: 0px -1px 5px -1px #d5d5d5;
      text-align: center;
    }
  }
</style>
<style lang="less" scoped>
  .el-dialog .ide-content {
    .content-box {
      height: 400px;
      word-break: break-all;
      text-indent: 20px;
      line-height: 20px;
      margin-top: 10px;
      overflow-y: auto;
      color: #333;

      table {
        border-collapse: collapse;

        td {
          padding: 5px 10px;
          border: 1px solid #DDD;
        }
      }
    }

    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre;
      font-size: 14px;
      font-weight: bold;
      color: #333;
    }

    .time {
      text-align: left;
      margin-top: 10px;
      color: #9A9A9A;
    }
  }

  .downloadArea {
    margin-bottom: -15px;

    ul {
      width: 100%;
      margin-top: 10px;
      text-align: left;
    }

    li {
      display: inline-block;
      line-height: 26px;
      background-color: #ecf4fc;
      margin: 0 15px 10px 0;
      color: #333;
      padding: 0 10px;

      .title {
        overflow: hidden;
        max-width: 150px;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
</style>